function togglesContent(header) {
    return $(header).siblings('.content').length > 0;
}

function syncExpanded(headers) {
    headers.each((i, el) => {
        $(el).attr('aria-expanded', $(el).siblings('.content').is(':visible'));
    });
}

const accordion = () => {
    const docBody = $(document.body);

    const headers = docBody.find('.collapsible .header').filter((i, el) => togglesContent(el));
    headers.attr({ role: 'button', tabindex: 0 });
    syncExpanded(headers);

    docBody.find('.collapsible .header').on('click', (e) => {
        const thisTarget = $(e.currentTarget);
        const thisContent = thisTarget.siblings('.content');
        const thisArrow = thisTarget.find('.icon-down-arrow-line');
        const thisIsClosed = thisTarget.find('.icon-isclosed');
        thisTarget.parents('.collapsible-wrapper').find('.collapsible .content').not(thisContent).slideUp();
        thisContent.slideToggle();
        if (thisArrow.length) {
            $('.collapsible .icon-down-arrow-line').not(thisArrow).removeClass('open');
            thisArrow.toggleClass('open');
        } else {
            $('.collapsible .icon-isclosed').not(thisIsClosed).removeClass('icon-isopen');
            thisIsClosed.toggleClass('icon-isopen');
        }
        setTimeout(() => syncExpanded(headers), 450);
    });

    docBody.on('keydown', '.collapsible .header', (e) => {
        if (e.key !== 'Enter' && e.key !== ' ' && e.key !== 'Spacebar') return;
        if (!togglesContent(e.currentTarget)) return;
        e.preventDefault();
        $(e.currentTarget).trigger('click');
    });
};

module.exports = {
    accordion,
};
